const STORAGE_PREFIX = "beentara_task_saved_views_";

export function savedViewsStorageKey(role) {
    return `${STORAGE_PREFIX}${role || "admin"}`;
}

export function loadSavedViews(role) {
    try {
        const raw = localStorage.getItem(savedViewsStorageKey(role));
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
}

export function persistSavedViews(role, views) {
    try {
        localStorage.setItem(savedViewsStorageKey(role), JSON.stringify(views));
    } catch {
        /* quota / private mode */
    }
}

export function snapshotFilters({
    statusFilter = "",
    priorityFilter = "",
    dueFilter = "",
    assigneeFilter = "",
    sortBy = "",
    viewFilter = "",
    viewMode = "",
    inboxPin = "",
} = {}) {
    return {
        statusFilter: statusFilter || "",
        priorityFilter: priorityFilter || "",
        dueFilter: dueFilter || "",
        assigneeFilter: assigneeFilter || "",
        sortBy: sortBy || "",
        viewFilter: viewFilter || "",
        viewMode: viewMode || "",
        inboxPin: inboxPin || "",
    };
}

export function captureSavedView(name, snapshot) {
    return {
        id: `sv-${Date.now()}`,
        name: String(name || "").trim(),
        createdAt: Date.now(),
        ...snapshotFilters(snapshot),
    };
}

export function viewsMatchSnapshot(view, snapshot) {
    if (!view || !snapshot) return false;
    const keys = [
        "statusFilter",
        "priorityFilter",
        "dueFilter",
        "assigneeFilter",
        "sortBy",
        "viewFilter",
        "viewMode",
        "inboxPin",
    ];
    return keys.every((key) => String(view[key] || "") === String(snapshot[key] || ""));
}
